import { useState, useEffect, useCallback } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listGroupedFunctionalityIndicatorsService } from "../services/listGroupedFunctionalityIndicators.service";

export const useGroupedFunctionalityIndicatorsQuery = (filters) => {
  const fetchData = useFetch();
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refetch = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  useEffect(() => {
    const fetchIndicators = async () => {
      try {
        setLoading(true);
        const service = listGroupedFunctionalityIndicatorsService(fetchData);
        const response = await service(filters);
        setGroupedData(response.data || []);
      } catch (error) {
        console.error("Error fetching grouped functionality indicators:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchIndicators, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, refreshKey]);

  return { groupedData, loading, refetch };
};
